module.exports = __webpack_public_path__ + "files/253841bef77eea75befc04d098f0a41c.png";